import React from 'react';

import { Profile } from '@entities/profile';

type OwnProps = {
	isBuyHistory?: boolean;
};

const ProfilePage: React.FC<OwnProps> = ({ isBuyHistory }) => {
	return <Profile isBuyHistory={isBuyHistory} />;
};

export default ProfilePage;
